<template>
  <div v-if="visible" :class="['notice-bar', type]">
    <span class="notice-text">{{ message }}</span>
    <div v-if="actions && actions.length" class="notice-actions">
      <button v-for="(a, i) in actions" :key="i" class="btn" @click="onClick(a)" :class="actionClass(a)">{{ a.label }}</button>
    </div>
    <button class="close" @click="$emit('close')">×</button>
  </div>
  </template>
<script>
export default {
  name: 'NoticeBar',
  props: { visible: { type: Boolean, default: false }, message: { type: String, default: '' }, type: { type: String, default: 'info' }, actions: { type: Array, default: () => [] } },
  methods: { onClick(a) { if (typeof a?.onClick === 'function') a.onClick() }, actionClass(a) { return a?.primary ? 'primary' : (a?.danger ? 'danger' : '') } }
}
</script>
<style scoped>
.notice-bar { position: fixed; top: 20px; left: 50%; transform: translateX(-50%); z-index: 9999; display: flex; gap: 12px; align-items: center; padding: 10px 14px; border-radius: 8px; box-shadow: 0 6px 24px rgba(0,0,0,0.15); color: #fff; min-width: 240px; max-width: 80vw; }
.notice-text { flex: 1; }
.notice-actions { display: flex; gap: 8px; }
.btn { border: none; border-radius: 6px; padding: 6px 12px; cursor: pointer; background: rgba(255,255,255,0.2); color: #fff; }
.btn.primary { background: #409eff; }
.btn.danger { background: #e65b60; }
.close { border: none; background: transparent; color: #fff; font-size: 18px; cursor: pointer; }
.info { background: #34495e; }
.success { background: #2ecc71; }
.warning { background: #e6a23c; }
.error { background: #f56c6c; }
</style>
